import {BigNumber} from 'ethers';
import { polygon } from "wagmi/chains";
import { polygonAmoy } from './viemCustomChains';


const toBN = (n: number): BigNumber => BigNumber.from(n);

export const DECIMALS = 18; //18 decimal places after floating point
export const E18 = toBN(10).pow(toBN(DECIMALS));
export const CONFIRMATIONS_NUM = 1;
export const CONFIRMATIONS_TIMEOUT = 60;
export const meeTokenAddress = "0xEB7eaB87837f4Dad1bb80856db9E4506Fc441f3D"; //0x5D018945F9c256A553D6B49053c174Bef4b14c6b;
export const meeTokenPageLink = "https://www.medievalempires.com/mee-token/";
export const stakingTermsAndConditionsLink = "https://www.medievalempires.com/staking-terms-and-conditions-land-slot/";
export const subgraphApiUrl = "https://gateway.thegraph.com/api/994de478484429404fb77b9e44d26a8a/subgraphs/id/Ag786QgpgWZ91UM77bfmnWwjqDwz8p25EBLrPwvZPKW5"; //https://api.studio.thegraph.com/query/105857/mee-land-staking/version/latest
export const apiBaseUrl = "https://api.medievalempires.io/api"; //https://api-develop.medievalempires.io/api

export const SENTRY_DSN = "https://eadd33edce4a049051ae84f2cd9d4e2c@o4511474026414080.ingest.de.sentry.io/4511474034802768";

export const CHAIN_CONFIG = {
    chain: polygon,
    explorerUrl: "https://www.polygonscan.com",
    isTestNet: false
}
